module.exports = __webpack_public_path__ + "img/d70dd.1cde4d42.svg";